<app-navigation
    [additionalContainerClasses]="[]"
    [automaticNavbarPadding]="false">
    <div class="space-y-4 md:space-y-8">
        <div class="relative">
            <div
                appNavigationScrollInverseColors
                defaultColor="transparent"
                class="aspect-h-3 aspect-w-2 relative md:aspect-h-[1.2] md:aspect-w-2 xl:aspect-w-3 2xl:aspect-w-4">
                <app-lazy-picture
                    [lazy]="false"
                    [configurations]="featuredImageConfiguration | async">
                </app-lazy-picture>
            </div>
            <div
                class="absolute top-0 h-full w-full bg-black bg-opacity-50"></div>
            <div
                class="absolute top-0 h-full w-full p-8 text-white md:pt-[calc(var(--navigation-height)+2rem)]">
                <div
                    class="mx-auto flex w-full max-w-screen-xl flex-col space-y-4">
                    <h1>
                        {{ (destination | async)?.name }} <br />
                        Travel Guide
                    </h1>
                    <p class="max-w-sm">
                        {{ (destination | async)?.description }}
                    </p>
                    <div class="mb-4 flex flex-row items-center pt-12">
                        <app-cta-button
                            class="z-20"
                            [additionalClasses]="['py-3 px-8 space-x-2 z-20']"
                            type="button"
                            (onClick)="scroll()">
                            <img
                                alt=""
                                class="inline h-4 -rotate-90 transform"
                                src="/assets/images/back-arrow.svg" />
                            <span>See all Topics</span>
                        </app-cta-button>
                    </div>
                </div>
            </div>
            <div
                class="absolute bottom-0 w-full -scale-x-100 transform text-white">
                <app-swirl></app-swirl>
            </div>
        </div>
        <div class="mx-auto max-w-screen-xl space-y-12 p-4 pb-24 md:space-y-24">
            @if ((topReads | async)?.length) {
                <app-knowledge-top-reads
                    class="block"
                    [topReadsDescription]="
                        (destination | async)?.topReadsDescription
                    "
                    [articles]="topReads | async">
                </app-knowledge-top-reads>
            }

            <div id="allTopics" #allTopics>
                @if (destination | async; as syncDestination) {
                    <app-knowledge-category-list
                        class="block"
                        [allTopicsDescription]="
                            (destination | async)?.allTopicsDescription
                        "
                        [destination]="
                            syncDestination
                        "></app-knowledge-category-list>
                }
            </div>

            @if (destination | async; as syncDestination) {
                <app-knowledge-variation-cards
                    class="block"
                    [destination]="
                        syncDestination
                    "></app-knowledge-variation-cards>
            }

            @if ((destination | async)?.faqs; as faqs) {
                <div>
                    <h2>FAQs</h2>
                    <app-faq-contentful-list
                        [faqs]="faqs"></app-faq-contentful-list>
                </div>
            }
        </div>
    </div>
</app-navigation>
